module.exports = __webpack_public_path__ + "static/media/3.968505e4.jpg";